import { useContext } from "react"
import Link from "components/Link"
import { sendEvent } from "scripts/GoogleAnalytics"
import { useT } from "react-polyglot-hooks"
import styled from "styled-components"
import TaxToggle from "components/styled/TaxToggle"
import { color, mq } from "helpers/styled"
import { RentingContext } from "../../RentingContext"

const Wrapper = styled.div`
  text-align: center;
  @media ${({ theme }) => theme.breakpoints.xs} {
    text-align: right;
  }
`

const Option = styled.a`
  display: inline-flex;
  background: ${({ theme, selected }) => theme.colors[selected ? "deepPink" : "white"]};
  color: ${({ theme, selected }) => theme.colors[selected ? "white" : "deepPink"]};
  border: none;
  font-size: 12px;
  font-weight: ${({ selected }) => (selected ? "600" : "400")};
  border-radius: 10px;
  line-height: 24px;
  padding: 7px 15px;
  min-width: 95px;
  margin-right: 5px;
  justify-content: center;
  width: 100%;
  margin-bottom: 5px;

  @media ${mq("xs")} {
    width: auto;
    margin-bottom: 0;
  }

  &:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }

  &:hover {
    background: ${({ theme, selected }) => (selected ? theme.colors.deepPink : color("lightGray"))};
    color: ${({ theme, selected }) => (selected ? theme.colors.white : color("deepPink"))};
  }
`

const OptionsContainer = styled.div`
  background: ${({ theme }) => theme.colors.lightGray};
  padding: 5px;
  border-radius: 10px;
  width: fit-content;
  display: inline-block;
  @media ${({ theme }) => theme.breakpoints.xs} {
    white-space: nowrap;
  }
`

const Toggle = styled(TaxToggle)`
  margin-right: 10px;
  margin-bottom: 10px;
`

export default function Tabs() {
  const { variant, page, withoutTaxes, setWithoutTaxes } = useContext(RentingContext)
  const t = useT()
  const hasPreOwned = variant === "pre-owned"

  const handleClick = val => {
    sendEvent("Tabs", { event_category: page, event_label: val })
  }

  return (
    <Wrapper>
      {variant === "commercial" && (
        <Toggle variant={variant} withoutTaxes={withoutTaxes} setWithoutTaxes={setWithoutTaxes} page={page} />
      )}
      <OptionsContainer>
        <Link page="stock">
          <Option type="button" onClick={() => handleClick("stock")} selected={variant === "stock"}>
            {t("renting.stock")}
          </Option>
        </Link>
        {hasPreOwned && (
          <Link page="pre-owned">
            <Option type="button" onClick={() => handleClick("pre-owned")} selected={variant === "pre-owned"}>
              {t("renting.pre-owned")}
            </Option>
          </Link>
        )}
        <Link page="commercial">
          <Option type="button" onClick={() => handleClick("commercial")} selected={variant === "commercial"}>
            {t("renting.commercial")}
          </Option>
        </Link>
      </OptionsContainer>
    </Wrapper>
  )
}
